module.exports = __webpack_public_path__ + "static/profile-pic-68aeb23ad4d2f5959380e8f958e9d1f1.png";